/**
 * Returns the full IANA timezone list (~400 entries) when the browser supports
 * `Intl.supportedValuesOf('timeZone')` (Chrome 99+, Safari 15.4+, FF 93+).
 * Falls back to a curated list covering the regions we care about.
 */
const FALLBACK_TIMEZONES = [
  'America/Anchorage',
  'America/Chicago',
  'America/Denver',
  'America/Halifax',
  'America/Los_Angeles',
  'America/Mexico_City',
  'America/New_York',
  'America/Phoenix',
  'America/Sao_Paulo',
  'America/Toronto',
  'America/Vancouver',
  'Asia/Dubai',
  'Asia/Hong_Kong',
  'Asia/Jakarta',
  'Asia/Kolkata',
  'Asia/Seoul',
  'Asia/Shanghai',
  'Asia/Singapore',
  'Asia/Tokyo',
  'Australia/Melbourne',
  'Australia/Sydney',
  'Europe/Amsterdam',
  'Europe/Berlin',
  'Europe/Istanbul',
  'Europe/London',
  'Europe/Madrid',
  'Europe/Paris',
  'Europe/Rome',
  'Pacific/Auckland',
  'Pacific/Honolulu',
  'UTC',
]

let cached = null

export function listTimezones() {
  if (cached) return cached
  try {
    if (typeof Intl?.supportedValuesOf === 'function') {
      const zones = Intl.supportedValuesOf('timeZone')
      if (Array.isArray(zones) && zones.length > 0) {
        cached = zones
        return cached
      }
    }
  } catch {
    // fall through
  }
  cached = FALLBACK_TIMEZONES
  return cached
}

export function detectTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || ''
  } catch {
    return ''
  }
}
